import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";

import { updateLanguageInHeaders } from "../../network/api";
import {
  storeApp,
  storeuserRole,
} from "../../Store/TemplateStore/template.action";

import DupontButton from "../DupontButton";
import { API_URLS } from "../../network/appUrls";
import { saveUser } from "../../network/cipAPI";

import "./index.scss";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import DupontIconButton from "../DupontIconButton";

const basePath = API_URLS.basePath;

const Header = (props) => {
  const accessUserPlant = useSelector((state) => state.accessUserPlant);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userName = useSelector((state) => state.userName);
  const userRole = useSelector((state) => state.userRole);
  const userEmail = useSelector((state) => state.userEmail);
  const companyName = useSelector((state) => state.companyName);
  const country = useSelector((state) => state.country);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    updateLanguageInHeaders(lng);
  };

  const payload = {
    email: userEmail,
    company: companyName,
    country: country,
    role: null,
    industry: null,
  };
  const saveUserDetails = async (payload) => {
    try {
      let response = await saveUser(payload);
      const { user_role } = response;
      dispatch(storeuserRole(`${user_role}`));
    } catch (error) {
      console.error("Error saving user information:", error);
    }
  };
  const onHomeClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    const path = `${basePath}plant`;
    navigate(path);
  };
  const handleBackToUserManagement = () => {
    dispatch(storeApp(null));
    dispatch({ type: "STORE_ACCESS_USER_PLANT", payload: false });
    navigate("/user-management");
  };

  const onMenuClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    setMenuOpen((prev) => !prev);
  };

  const handleManageAccess = () => {
    dispatch(storeApp(null));
    setMenuOpen(false);
    navigate(`${basePath}admin-portal`);
  };

  const handleManageUser = () => {
    dispatch(storeApp(null));
    setMenuOpen(false);
    navigate(`${basePath}user-management`);
  };

  return (
    <div className="header_container">
      <div className="home flex-between-center ">
        <div>
          <DupontIconButton
            onClick={onHomeClicked}
            tooltip={t("adminPage.home")}
          >
            <FontAwesomeIcon icon={faHome} />
          </DupontIconButton>
          {/* when sign out functionality is implemented remove admin condition for icon and keep it for admin features */}
          {userRole === "admin" && (
            <div className="admin-menu-container" ref={menuRef}>
              <DupontIconButton>
                <FontAwesomeIcon icon={faCircleUser} onClick={onMenuClicked} />
              </DupontIconButton>
              {menuOpen && (
                <div className="admin-menu-dropdown">
                  <div className="admin-menu-item" onClick={handleManageAccess}>
                    {t("adminPage.manageAcess")}
                  </div>
                  <div className="admin-menu-item" onClick={handleManageUser}>
                    {t("adminPage.userManagement")}
                  </div>
                </div>
              )}
            </div>
          )}

          <span className="welcome-container ">{`${t(
            "welcomeString.welcome"
          )}, ${userName}`}</span>
        </div>
        <div className="padding-80 ">
          <DupontButton
            type="tertiary"
            customClass="button-terninarty-custom-width"
            onClick={() => changeLanguage("en")}
            disabled={props.activeStep && props.activeStep > 0}
          >
            en
          </DupontButton>{" "}
          <DupontButton
            type="tertiary"
            customClass="button-terninarty-custom-width"
            onClick={() => changeLanguage("zh")}
            disabled={props.activeStep && props.activeStep > 0}
          >
            中文
          </DupontButton>
        </div>
      </div>

      <div className="header-divider" />
      <div className="container-dupont-icon">
        <div className="container-dupont-icon-flex">
          <div className="dupont-icon" onClick={onHomeClicked}>
            <img src={require("../../assets/DuPont_Logo.png")} />
            <div className="water-solution">
              {t("headerString.waterSolution")}
            </div>
          </div>
          {accessUserPlant && (
            <div className="back-user-management-btn">
              <DupontButton
                type="tertiary"
                customClass="button-terninarty-custom-width"
                onClick={handleBackToUserManagement}
              >
                {t("addNewPlant.backUserManagement")}
              </DupontButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
